import { createRoot } from 'react-dom/client'
import './index.css'
import './styles/app-shared.css'
import './styles/mui-buttons.css'
import './styles/purchase-contract.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <App />,
)
